define('fukit/view/block/confirm.modal.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util'],function(require, exports, module) {
  //prettier-ignore
  var _          = require('underscore'),
      UIKit      = require('uikit/uikit'),
      ExtendUtil = require('../../helpers/extend.util');

  var ConfirmModalView = UIKit.Modal2.extend({
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      basic: true,
      closeable: true,
      size: 'small',
    }),

    internalViewOptions: UIKit.Modal2.extendInternalViewOptions({
      headerView: ExtendUtil.extendOptionValueWithDefaults('header', {
        text: 'Are you sure?',
      }),

      contentView: ExtendUtil.extendOptionValueWithDefaults('content', {
        type: UIKit.Modal2.SimpleContentView,
        icon: 'send outline icon',
        text: '',
      }),

      actionsView: ExtendUtil.extendOptionValueWithDefaults('actions', {
        components: [
          {
            type: UIKit.Modal2.DenyButtonView,
            text: 'Cancel',
            inverted: true,
            color: 'basic',
            name: 'denyButton',
          },
          {
            type: UIKit.Modal2.ConfirmButtonView,
            color: 'positive',
            text: 'Confirm',
            name: 'confirmButton',
          },
        ],
      }),
    }),
  });

  module.exports = ConfirmModalView;
});

